import { Handle, NodeProps, Position, useUpdateNodeInternals } from 'reactflow';
import { SelectionCard } from '@evoach/ui-components';
import { useIntl } from 'react-intl';
import { useEffect } from 'react';

import { translateKey, useGlobalStyles } from './base.node';
import { CustomNodeMenu } from './base.nodemenu';

/*
  CoachMessage react-flow node for module builder graph canvas
*/

export const SelectionCardNode: React.FC<NodeProps<any>> = (nodeProps: any) => {
  const classes = useGlobalStyles();
  const intl = useIntl();
  const payload = nodeProps.data.state.entry[0].payload;

  // update internal position coordinates of handles when changing the number
  // of handles in this node.
  const updateNodeInternals = useUpdateNodeInternals();
  useEffect(() => {
    updateNodeInternals(nodeProps.id);
  }, [payload.keyTexts.length, nodeProps.id, updateNodeInternals]);

  const calculateHandlePosition = (handleCount: number, handleIndex: number) =>
    `${(100 / (handleCount + 1)) * (handleIndex + 1)}%`;

  const sourceHandles = payload.keyTexts?.map(
    (keyText: string, index: number) => (
      <Handle
        id={keyText}
        key={keyText + index}
        className={classes['react-flow__handle']}
        type="source"
        position={Position.Bottom}
        style={{
          left: calculateHandlePosition(payload.keyTexts?.length ?? 1, index),
        }}
      />
    )
  );

  return (
    <>
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={nodeProps.isConnectable}
        className={classes['react-flow__handle']}
      />
      <div
        className={nodeProps.selected ? classes.selectStyletrue : classes.root}
        style={{ width: '500px' }}
      >
        <CustomNodeMenu nodeid={nodeProps.id} />
        <SelectionCard
          buttonTexts={payload.buttonTexts.map((textkey: string) =>
            translateKey(intl, textkey)
          )}
          keyTexts={payload.keyTexts}
          saveResultTo={payload.saveResultTo}
          displayInColums={payload.displayInColums}
          width={500}
        />
      </div>
      {sourceHandles}
    </>
  );
};
